import { Hero } from '@/components/generic/Hero';
import { ReactNode } from 'react';

export const AdminHero = ({ children }: { children: ReactNode }) => {
  return <Hero title="Administration">{children}</Hero>;
};
